import React from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@techstyle/react-components';

export default function FilterIcon({
  size = '1em',
  color = 'currentColor',
  ...rest
}) {
  const theme = useTheme();
  const fill = theme.colors[color] || color;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9478 4.23255C16.9478 3.938 16.7151 3.69922 16.4281 3.69922H13.9997C13.7128 3.69922 13.4801 3.938 13.4801 4.23255C13.4801 4.5271 13.7128 4.76589 13.9997 4.76589H16.4281C16.7151 4.76589 16.9478 4.5271 16.9478 4.23255ZM10.7681 4.23255C10.7681 3.938 10.5355 3.69922 10.2485 3.69922L1.75832 3.69922C1.47135 3.69922 1.23872 3.938 1.23872 4.23255C1.23872 4.5271 1.47135 4.76589 1.75832 4.76589L10.2485 4.76589C10.5355 4.76589 10.7681 4.5271 10.7681 4.23255Z"
        fill={fill}
      />
      <ellipse cx="12.1747" cy="4.23477" rx="1.58824" ry="1.6" stroke={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9478 12.7658C16.9478 12.4712 16.7151 12.2324 16.4281 12.2324H13.9997C13.7128 12.2324 13.4801 12.4712 13.4801 12.7658C13.4801 13.0603 13.7128 13.2991 13.9997 13.2991H16.4281C16.7151 13.2991 16.9478 13.0603 16.9478 12.7658ZM10.7681 12.7658C10.7681 12.4712 10.5355 12.2324 10.2485 12.2324L1.75832 12.2324C1.47135 12.2324 1.23872 12.4712 1.23872 12.7658C1.23872 13.0603 1.47135 13.2991 1.75832 13.2991H10.2485C10.5355 13.2991 10.7681 13.0603 10.7681 12.7658Z"
        fill={fill}
      />
      <ellipse cx="12.1747" cy="12.768" rx="1.58824" ry="1.6" stroke={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.23877 8.50013C1.23877 8.20558 1.4714 7.9668 1.75837 7.9668H4.18678C4.47375 7.9668 4.70638 8.20558 4.70638 8.50013C4.70638 8.79468 4.47375 9.03346 4.18678 9.03346H1.75837C1.4714 9.03346 1.23877 8.79468 1.23877 8.50013ZM7.41839 8.50013C7.41839 8.20558 7.65103 7.9668 7.938 7.9668L16.4282 7.9668C16.7152 7.9668 16.9478 8.20558 16.9478 8.50013C16.9478 8.79468 16.7152 9.03346 16.4282 9.03346H7.938C7.65103 9.03346 7.41839 8.79468 7.41839 8.50013Z"
        fill={fill}
      />
      <ellipse
        cx="1.58824"
        cy="1.6"
        rx="1.58824"
        ry="1.6"
        transform="matrix(-1 0 0 1 7.41162 6.90234)"
        stroke={fill}
      />
    </svg>
  );
}

FilterIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
